<template>
    <div class="newevents">
        <div>
            <div class="col-md-10 mb-4 mx-0 mx-md-4">
                <span class="pstitle">Upcoming Events</span>
            </div>
        </div>
        <div class="row align-items-md-stretch" v-if="Events.length">
            <template v-for="(event, index) in this.Events" :key="index">
                <event-card :event="event"></event-card>
            </template>
        </div>
        <div v-else>
            We are sorry, No events found!!
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import getEndPoint, { eventsAPI } from '../../constants/api.config'
    import EventCard from "../atoms/EventCard.vue";
    export default {
        name: "EventsList",
        props: ["PrimaryFilter"],
        components: {
            EventCard
        },
        data() {
            return {
                Events: []
            }
        },
        methods: {
            getEvents(data) {
                let b = [];
                data.forEach(element => {
                    b.push(
                        {
                            eventid: element.eventID,
                            event_name: element.eventName,
                            start_date: element.startDate,
                            end_date: element.endDate,
                            brand: element.brand,
                            publishingURL: element.publishingURL,
                            description: element.description,
                            location:element.location
                        }
                    );
                });

                return b;
            },
            BindEventsData()
            {
                let searchFilters= "";
                if(this.PrimaryFilter!=null && this.PrimaryFilter.type!=undefined && this.PrimaryFilter.type!="")
                {
                    searchFilters = this.PrimaryFilter.type=="brand"? "Brand=":(this.PrimaryFilter.type=="dealer"?"DealerLocationID=":"");
                    axios.get(getEndPoint(eventsAPI) + searchFilters + this.PrimaryFilter.key)
                    .then((response) => (
                        this.Events = this.getEvents(response.data)
                    ))
                    .catch((error) => console.log(error));
                }
            }
        },
        mounted() {
            this.BindEventsData();
        },
        watch: { 
            PrimaryFilter: function() { 
                this.BindEventsData();
            }
        }
    };
</script>